<template>
  <section class="page-container">
    <h1>Admin & CMS</h1>
    <div class="main flex">
      <el-aside>
        <div class="title">Marketing Tools</div>
        <el-menu :default-active="$route.path">
          <el-menu-item
            v-for="(item, index) in toolList"
            :key="index"
            :index="item.path">
            <router-link
              :to="item.path"
              class="link">
              <span class="item-title">{{ item.title }}</span>
            </router-link>
          </el-menu-item>
        </el-menu>

        <div class="title">Admin</div>
        <el-menu :default-active="$route.path">
          <el-menu-item
            v-for="(item, index) in adminList"
            :key="index"
            :index="item.path">
            <router-link
              :to="item.path"
              class="link">
              <span
                v-if="item.icon"
                class="icon">
                <font-awesome-icon :icon="item.icon"/>
              </span>
              <span class="item-title">{{ item.title }}</span>
            </router-link>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <router-view class="child"></router-view>
    </div>
  </section>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      toolList:[
        // {
        //   title: 'Promotions',
        //   path: '/admin-cms/promotions',
        // },
        {
          title: 'Blog',
          path: '/admin-cms/blog',
        },
        {
          title: 'Notice',
          path: '/admin-cms/notice',
        },
        {
          title: 'Coupons',
          path: '/admin-cms/coupons',
        },
        // {
        //   title: 'Campaign Code',
        //   path: '/admin-cms/campaign-code',
        // },
        // {
        //   title: 'Trial Codes',
        //   path: '/admin-cms/trial-codes',
        // },
        {
          title: 'Communications Subscribers',
          path: '/admin-cms/communications',
        },
        // {
        //   title: 'Dashboard',
        //   path: '/dashboard',
        // },
        // {
        //   title: 'Quick Quote Report',
        //   path: '/administration/quick/report',
        // },
        // {
        //   title: 'Refer Case/SME Ticket Report',
        //   path: '/administration/ticket/report',
        // },
        // {
        //   title: 'Link Report',
        //   path: '/administration/linkreport',
        // },
        //
        // {
        //   title: 'Blog Ad Report',
        //   path: '/admin-cms/blog-ad',
        // },
        // {
        //   title: 'Marketing Reports',
        //   path: '/admin-cms/marketing-report',
        // },
      ],
      adminList:[
        {
          title: 'My CS Account',
          path: '/admin-cms/change-password',
        },
        {
          title: 'Gift Cards',
          path: '/administration/gift',
        },
        // {
        //   title: 'Product Controls',
        //   path: '/admin-cms',
        //   icon: 'user-lock'
        // },
        // {
        //   title: 'CS Log',
        //   path: '/admin-cms',
        //   icon: 'user-lock'
        // },
        // {
        //   title: 'Block List',
        //   path: '/admin-cms/block-list',
        //   icon: 'user-lock'
        // },
        // {
        //   title: 'Policy Log',
        //   path: '/admin-cms/policy-log',
        //   icon: 'user-lock'
        // },
        {
          title: 'SMS Log',
          path: '/admin-cms/sms-log',
        },
        {
          title: 'Email Log',
          path: '/admin-cms/email-log',
        },
        // {
        //   title: 'Audit Log',
        //   path: '/admin-cms/audit-log',
        //   icon: 'user-lock'
        // },
        // {
        //   title: 'Make / Model',
        //   path: '/admin-cms/car-class-list',
        //   icon: 'user-lock'
        // }
      ],
    }
  },
  methods: {

  },
}
</script>
<style lang='scss' scoped>
.page-container{
  background: #fff;
  margin: -20px;
  padding: 30px 70px;
  h1{
    font-weight: 600;
    font-size: 24px;
    height: 36px;
    line-height: 36px;
    letter-spacing: 0.3px;
    color: #24292E;
    padding: 0;
  }
  .main{
    margin-top: 30px;
    .el-aside{
      width: 280px !important;
      margin-right: 30px;
      .title{
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        color: #24292E;
      }
      .el-menu{
        border-radius: 6px;
        margin: 15px 0 30px 0;
        .el-menu-item{
          background: #FAFBFC;
          width: 280px;
          height: 45px;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: -0.15px;
          border: 1px solid #E1E4E8;
          &:first-child{
            border-top-left-radius: 6px;
            border-top-right-radius: 6px;
          }
          &:last-child{
            border-bottom-left-radius: 6px;
            border-bottom-right-radius: 6px;
          }
          & + .el-menu-item{
            border-top: 0;
          }
          &.is-active{
            border-left: 3px solid #f9816c;
            background: #ffffff;
          }
          &:hover{
            background: #f6f8fa;
          }
          .link{
            text-decoration: none;
            display: flex;
            align-items: center;
            height: 45px;
            line-height: 45px;
            .item-title{
              color: #24292E;
            }
            .icon{
              color: #24292E;
              margin-right: 7px;
              display: inline-block;
              width: 18px;
              height: 16px;
              font-weight: 900;
              font-size: 14px;
              line-height: 16px;
            }
          }
        }
      }
    }
    .child{
      flex: 1;
    }
  }
}
</style>
